import styles from './textarea.module.scss'

export function Textarea ({ textAreaRef, onKeyUp, onKeyPress, onKeyDown, onChange, value, placeholder, focus }) {
  return (
    <textarea
       
      autoFocus={focus}
      ref={textAreaRef}
      onKeyUp={e => onKeyUp?.(e)}
      onKeyPress={e => onKeyPress?.(e)}
      onKeyDown={e => onKeyDown?.(e)}
      onChange={e => onChange?.(e.target.value)}
      value={value}
      className={styles.input}
      placeholder={placeholder}
    />
  )
}
